import { isNil, isString } from 'lodash';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import withOptions from 'utils/functions/withOptions.util';
import replaceNaN from 'utils/values/replaceNaN.util';

const DEFAULT_MAX_LENGTH = 120;

const validateNameLength = withOptions(({ value: v, max: m }) => {
  // can't return neigher true nor false for invalid name
  if (isNil(v) || !isString(v)) {
    return null;
  }

  const len = fromAnyToTrimmed(v).length;
  const max = replaceNaN(DEFAULT_MAX_LENGTH, fromAnyToInteger(m));

  return len <= max;
});

// noinspection JSUnusedGlobalSymbols
export default validateNameLength;
